import React from 'react';
import CheckIcon from '@wix/da-ds/pkg/Icons/16x16/Check';
import AddIcon from '@wix/da-ds/pkg/Icons/16x16/Add';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import { useWatchButton } from '../../../WatchButton/useWatchButton';
const WatchButton = ({ user })=>{
    const { isWatching, text, onClick, biData } = useWatchButton(user);
    return /*#__PURE__*/ React.createElement(GhostButton, {
        size: "small",
        variant: "main",
        biData: biData,
        icon: isWatching ? CheckIcon : AddIcon,
        onClick: onClick
    }, text);
};
WatchButton.displayName = 'WatchButton';
export default WatchButton;

//# sourceMappingURL=WatchButton.js.map